<template>
    <div class="header-shell">

        <!-- MOBILE HEADER -->
        <div v-if="!$q.screen.lt.md" class="navigation">
            <q-breadcrumbs v-if="breadcrumbHistory.length" class="header-breadcrumbs" gutter="sm">
                <q-breadcrumbs-el label="Home" to="/" />

                <q-breadcrumbs-el v-for="(item, index) in breadcrumbHistory" :key="item.path + index"
                    :label="item.label" :to="item.path" />
            </q-breadcrumbs>
        </div>

        <div v-if="$q.screen.lt.md" class="mobile-sticky-header">

            <!-- Top row: menu | logo | logout -->
            <div class="mobile-top-row">
                <q-btn size="20px" flat dense round no-caps icon="menu" class="logout-link" @click="showDrawer" />

                <img class="brand-logo-sera" src="../../assets/SERA_LOGO.png" />

                <q-btn size="20px" flat dense round no-caps icon="logout" class="logout-link" @click="logout" />
            </div>

            <!-- Breadcrumbs row -->
            <div class="breadCrumbClass" v-if="breadcrumbHistory.length">
                <q-breadcrumbs class="header-breadcrumbs mobile-crumbs" gutter="xs">
                    <q-breadcrumbs-el label="Home" to="/" />

                    <q-breadcrumbs-el v-if="showEllipsis" label="..." />

                    <q-breadcrumbs-el v-for="(item, index) in visibleBreadcrumbs" :key="item.path + index"
                        :label="item.label" :to="item.path" />
                </q-breadcrumbs>
            </div>

            <!-- User ID row -->
            <div class="mobile-userid-row">
                <q-badge outline class="q-ml-sm" color="primary" :label="$store.state.userId" />
            </div>

        </div>


        <!-- DESKTOP HEADER -->
        <div class="app-header">

            <div v-if="!$q.screen.lt.md" class="row">

                <div class="col-11 items-center brand-class">

                    <div class="menu-btn">
                        <q-btn v-if="!$q.screen.lt.md" flat dense rounded @click="showDrawer">
                            <q-icon name="menu" :size="$q.screen.lt.md ? '30px' : '28px'" />
                        </q-btn>
                    </div>

                    <img class="brand-logo-sera" src="../../assets/SERA_LOGO.png" />
                </div>

                <div class="col-1 logout-btn">
                    <q-btn :size="$q.screen.lt.md ? '18px' : '20px'" flat dense no-caps icon="logout"
                        class="logout-link" @click="logout" />
                </div>

            </div>


            <!-- USER ID / BACK BUTTON -->
            <div v-if="!$q.screen.lt.md" class="userId">

                <q-btn flat dense color="primary" label="Go Back" icon="arrow_back" :disable="!canGoBack"
                    @click="goBack" />

                <div>
                    <!-- User Id: -->
                    <q-badge outline class="q-ml-sm" color="primary" :label="$store.state.userId" />
                </div>

            </div>


            <!-- PAGE HEADER -->
            <div class="brand-mark row">

                <div class="col-1"></div>

                <div class="header-content col-11">

                    <!-- ========================= -->
                    <!-- BREADCRUMBS -->
                    <!-- ========================= -->



                    <!-- HEADING -->
                    <h1 v-if="!isHaedingHide">
                        {{ heading }}
                    </h1>


                    <!-- SUB HEADING -->
                    <p v-if="!isHaedingHide" class="header-copy sub-heading">
                        {{ subHeading }}
                    </p>


                    <!-- CREATE BUTTON -->
                    <q-btn v-if="allowedCreate && !isFormPage" no-caps icon="add" :label="btnHeading" title="Create"
                        class="new-project-btn q-mt-md create-btn" @click="createVisit" />

                </div>

            </div>

        </div>
    </div>
</template>


<script>
    export default {

        props: [
            'heading',
            'subHeading',
            'isFormPage',
            'btnHeading',
            'isHaedingHide',
            'allowedCreate'
        ],

        data() {
            return {
                breadcrumbHistory: [],
            };
        },


        methods: {

            goBack() {
                if (this.canGoBack) {
                    this.$router.go(-1);
                }
            },


            showDrawer() {
                this.$emit('show-drawer');
            },


            createVisit() {
                this.$emit('create-visit');
            },


            logout() {
                this.$emit('logout');

                sessionStorage.setItem(
                    'hasInAppHistory',
                    'false'
                );
            },


            loadBreadcrumbHistory() {

                const saved =
                    sessionStorage.getItem('breadcrumbHistory');

                this.breadcrumbHistory = saved
                    ? JSON.parse(saved)
                    : [];

                // Current route ko initial history mein add karo
                this.updateBreadcrumb();
            },


            updateBreadcrumb() {

                const route = this.$route;

                const label =
                    route.meta?.breadcrumb ||
                    route.meta?.title;

                if (!label) {
                    return;
                }

                const path = route.fullPath;

                // Home par history reset
                if (path === '/') {
                    this.breadcrumbHistory = [];
                    this.saveBreadcrumbHistory();
                    return;
                }

                /*
                 * Check karo current route already
                 * breadcrumb history mein hai ya nahi.
                 */
                const existingIndex =
                    this.breadcrumbHistory.findIndex(
                        item => item.path === path
                    );

                /*
                 * Agar route pehle se hai,
                 * to usko dobara add nahi karna.
                 *
                 * Example:
                 *
                 * Home
                 * Visit List
                 * Visit Form
                 * Visit List
                 *
                 * becomes:
                 *
                 * Home
                 * Visit List
                 */
                if (existingIndex !== -1) {

                    this.breadcrumbHistory =
                        this.breadcrumbHistory.slice(
                            0,
                            existingIndex + 1
                        );

                } else {

                    /*
                     * NEW route
                     * existing history ko touch nahi karna.
                     */
                    this.breadcrumbHistory.push({
                        path: path,
                        label: label,
                    });
                }

                this.saveBreadcrumbHistory();
            },


            saveBreadcrumbHistory() {

                sessionStorage.setItem(
                    'breadcrumbHistory',
                    JSON.stringify(this.breadcrumbHistory)
                );
            },
        },
        created() {
            this.loadBreadcrumbHistory();
        },

        computed: {

            /*
             * Vue Router ke matched routes se
             * breadcrumb automatically generate honge.
             */
            // breadcrumbRoutes() {

            //     console.log('this.$route.matched: ', this.$route.matched);
            //     return this.$route.matched.filter(
            //         route =>
            //             route.meta &&
            //             route.meta.breadcrumb
            //     );
            // },

            /*
             * Mobile pe sirf last 2 crumbs dikhao,
             * warna line wrap ho ke ajeeb lagta tha.
             */
            visibleBreadcrumbs() {
                return this.breadcrumbHistory.slice(-2);
            },

            showEllipsis() {
                return this.breadcrumbHistory.length > 2;
            },

            canGoBack() {

                return (
                    sessionStorage.getItem(
                        'hasInAppHistory'
                    ) === 'true'
                );
            }
        },
        watch: {
            '$route.fullPath'() {
                this.updateBreadcrumb();
            },
        },
    };
</script>


<style scoped lang="scss">
@import '../../styles/quasar.scss';

.header-shell {
    max-width: 100%;
    position: relative;
    top: 0;
    left: 0;
    z-index: initial;
}


.app-header {
    min-height: 150px;
    width: 100%;
    padding: 40px 18px 24px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    color: $primary;
    position: relative;
    background: #fff;
    z-index: initial;
}


.project-shell {
    min-width: 100%;
    min-height: 170px;
}


.new-project-btn {
    min-height: 38px;
    font-size: 15px;
    color: #fff;
    background: $primary-gradient;
    border-radius: 8px;
}


.header-copy {
    font-size: 14px;
}


.header-content {
    position: relative;
}


.header-content h1 {
    font-size: 18px;
    line-height: 1.2;
    font-weight: 700;
    margin: 0;
}


.header-content p {
    margin: 7px 0 0;
    font-size: 14px;
    opacity: 0.85;
    color: $magenta;
}


.brand-logo-sera {
    height: 26px;
    margin-bottom: 10px;
}


.brand-class {
    display: flex;
    align-items: center;
}


.header-actions {
    position: relative;
    top: 14px;
    right: 14px;
    margin: 0;
    display: flex;
    gap: 8px;
}


.logout-link {
    color: $primary;
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 18px;
}


.brand-mark {
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.16);
}


.menu-btn {
    margin-right: 30px;
    text-align: left;
    display: none;
}


.create-btn {
    position: relative !important;
}


.logout-btn {
    text-align: end;
}


/* ==========================================
   BREADCRUMBS
   ========================================== */

.header-breadcrumbs {
    margin-bottom: 10px;
    font-size: 11px;
    line-height: 1;
}


/*
 * Breadcrumb links
 */
.header-breadcrumbs ::v-deep .q-breadcrumbs__el {
    color: $primary;
    font-weight: 400;
}


/*
 * Current / last breadcrumb
 */
.header-breadcrumbs ::v-deep .q-breadcrumbs__el:last-child {
    color: $magenta;
    font-weight: 400;
}


/*
 * Separator
 */
.header-breadcrumbs ::v-deep .q-breadcrumbs__separator {
    color: $magenta;
    opacity: 0.6;
}


/* ==========================================
   DESKTOP
   ========================================== */

@media (min-width: 641px) {

    .header-actions {
        position: static;
        margin-left: auto;
    }


    .brand-mark {
        min-height: 48px;
        box-sizing: border-box;
    }


    .menu-btn {
        margin-right: 30px;
        text-align: left;
        display: inline-block;
    }


    .create-btn {
        position: absolute !important;
        right: 0;
        top: 0;
    }


    .header-breadcrumbs {
        margin-bottom: 12px;
    }
}


/* ==========================================
   MOBILE
   ========================================== */

@media (max-width: 641px) {
    .header-breadcrumbs { margin-bottom: 8px; font-size: 12px; }
    .app-header {
        background: transparent;
    }


    .header-content h1 {
        font-size: 18px;
    }

}

.userId {
    display: flex;
    justify-content: space-between;
}


/* ==========================================
   NEW MOBILE STICKY HEADER LAYOUT
   ========================================== */

.mobile-sticky-header {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 1 !important;
    background: #fff;
    padding: 14px 16px 12px;
    box-shadow: 0 12px 28px rgba(27, 67, 77, 0.08);
}

.mobile-top-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.mobile-top-row .brand-logo-sera {
    height: 24px;
    margin: 0;
}

.breadCrumbClass {
    margin-bottom: 8px;
}

.mobile-crumbs {
    flex-wrap: nowrap !important;
    white-space: nowrap;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    font-size: 12px;
}

.mobile-crumbs::-webkit-scrollbar {
    display: none;
}

.mobile-userid-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 13px;
    color: $primary;
}
</style>